import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
const Excel = require("exceljs");
import { saveAs } from "file-saver";
import { CommonService } from "src/app/services/common.service";
import * as XLSX from "xlsx";
import { StorageService } from "../../services/storage.service";

const dateRangeValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const startDate = control.get("start_date")?.value;
  const endDate = control.get("end_date")?.value;

  if (!startDate || !endDate) {
    return { required: true };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (end < start) {
    return { invalidRange: true };
  }

  return null;
};
@Component({
  selector: "app-schedule",
  templateUrl: "./schedule.component.html",
  styleUrls: ["./schedule.component.css"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class ScheduleComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  expandedElement = false;
  @ViewChild("resForm") myDiv: ElementRef;
  active = 1;
  TimeTableForm: FormGroup;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  swal: any;
  total_count = 0;
  stucreate: any;
  timeList: any[];
  gettime: any;
  edittime: any;
  is_active = false;
  deletetime: any;
  editid: any;
  department: any;
  dept = [];
  pass: any;
  start_date: string;
  course: Object;
  courseData: any;
  batch: Object;
  batchData: any;
  maxDate: Date;
  maxCreateEditDate: Date;
  classroom: Object;
  class: any;
  updatetime: Object;
  startDate: any;
  endDate: any;
  startTime: any;
  endTime: any;
  dayone: any;
  daytwo: any;
  daythree: any;
  dayfour: any;
  dayfive: any;
  daysix: any;
  dayseven: any;
  subject: Object;
  subjectData: any;
  prodessor: Object;
  prodessorData: any;
  dayone1: any;
  dayone2: any;
  dayone3: any;
  dayone4: any;
  dayone5: any;
  dayone6: any;
  dayone7: any;
  editbut: boolean;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  statusupdate: Object;
  department_id: any;
  classroom_id: string;
  subject_id: any;
  batch_id: any;
  professor_id: any;
  startDateFil: string;
  endDateFil: string;
  endTimeFil: any;
  startTimeFil: any;
  datecheck: any;
  datearr: any;
  datemin: any;
  datemax: any;
  date1: Date;
  date2: Date;
  date3: Date;
  bulk_form: FormGroup;
  selectedFiles: any;
  view_File_name: any;
  datecheckstatus = false;
  schedulebulk: any;
  d: Date | string;
  d1: Date | string;
  start_time: string;
  end_date: string;
  end_time: string;
  bulktimeupload: Object;
  Time: any;
  timebulk = [];
  select_all: string;
  statusform: string;
  total: number;
  pagedItems: any[];
  p: number;
  filter: any;
  searchForm: FormGroup;
  filter_from: string;
  filter_end: string;
  chiparray = [];
  filtervalues: boolean;
  startdate: string;
  enddate: string;
  entryFields: boolean = false;
  createNew: boolean = true;
  requestListData: any = [];
  liveStream: any = 0;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  findedFilteredVal: any;
  backendValidationErrors: any;
  isDisabled: boolean;
  isActiveProfessor = true;
  inActiveProffData: {
    id: any;
    username: string;
    first_name: string;
    last_name: string;
    email_address: any;
    hod: boolean;
    userByRole: { id: number; role: string; userRole: { role_id: number } }[];
  };
  findedInactiveProfessorId: any;
  minStartTime: string;
  professorData: any;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    public spinner: NgxSpinnerService,
    public fileupload: CommonService,
    private renderer: Renderer2
  ) { }
  selectedCar: number;

  cars = [
    { id: 1, name: "Volvo" },
    { id: 2, name: "Saab" },
    { id: 3, name: "Opel" },
    { id: 4, name: "Audi" },
  ];
  data: Array<Object> = [
    { id: 0, name: "Active" },
    { id: 1, name: "In Active" },
  ];
  public form1 = {
    vedioname: "hit",
    video: null,
  };
  async ngOnInit() {
    this.maxDate = new Date();
    this.maxCreateEditDate = new Date();
    this.minDate = new Date();
    this.date1 = new Date();
    this.date2 = new Date();
    this.date3 = new Date();
    this.date1.setDate(this.date1.getDate());
    this.maxCreateEditDate.setDate(this.maxCreateEditDate.getDate());

    this.searchForm = this.fb.group({
      id: [""],
      date: [""],
      depname: [null],
      classname: [null],
      subname: [null],
      batchname: [null],
      proname: [null],
      session: [null],
    });

    this.TimeTableForm = this.fb.group(
      {
        id: [""],
        department_id: ["", [Validators.required]],
        classroom_id: ["", [Validators.required]],
        subject_id: ["", [Validators.required]],
        batch_id: ["", [Validators.required]],
        professor_id: ["", [Validators.required]],
        start_date: ["", [Validators.required]],
        end_date: ["", [Validators.required]],
        start_time: ["", [Validators.required]],
        end_time: ["", [Validators.required]],
        day_one: [""],
        day_two: [""],
        day_three: [""],
        day_four: [""],
        day_five: [""],
        day_six: [""],
        day_seven: [""],
        session: [""],
        isActive: [""],
      },
      { validator: dateRangeValidator }
    );
    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });
    this.page = 1;
    this.TimeTableForm.valueChanges.subscribe((data) => {
      this.backendValidationErrors = null;
      if (!data.batch_id) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    });
    await this.getAllDropdown();
    await this.getPage(this.page, true);
  }

  expandRow(eList) {
    this.timeList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }

  collapseRow(eList) {
    this.timeList.forEach((list) => {
      list["isExpand"] = false;
    });
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.TimeTableForm.reset();
    this.submitted = false;
  }
  openEdit() {
    // this.res();
    this.startTime = "";
    this.endTime = "";
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.TimeTableForm.reset();
    this.submitted = false;

    this.getAllDropdown();
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.TimeTableForm.reset();
    this.createNew = true;
  }
  async getPage(page: number, disableCall: boolean) {

    this.page = page;
    if (!disableCall) {
      await this.getTimeTable(true);
    }
    const res = await this.serverCall(this.timeList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.TimeTableForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }

  async getAllDropdown(isFilterOpen?) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );
    this.dept = this.department["content"];
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );
    this.subjectData = this.subject["content"];
    this.prodessor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );
    this.prodessorData = this.prodessor["content"];
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );
    this.class = this.classroom["content"];
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );
    this.batchData = this.batch["content"];
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );
    //this.searchForm.reset();
    this.sessionData = session["content"];
    this.forms1["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    );

    this.onSessionChangeEvent(true);
    if (!isFilterOpen) {
      this.Filter();
    } else {
      this.spinner.hide();
    }
  }

  async onSessionChangeEvent(isInitLoad?) {
    // this.forms1["date"].setValue(null);
    // this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        // this.forms1["date"].setValue([new Date(), new Date()]);
        // this.getFilterDate([new Date(), new Date()]);
      }
    } else {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();
  }

  async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.prodessorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subname: null,
    });
  }

  stdate(e) {
    this.startDate = moment(e).format("YYYY-MM-DD");
  }
  endate(e) {
    this.endDate = moment(e).format("YYYY-MM-DD");
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD 00:00:00");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD 23:59:59");
      this.startdate = moment(this.filter[0]).format("YYYY-MM-DD");
      this.enddate = moment(this.filter[1]).format("YYYY-MM-DD");
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }
  sttime(e) {
    this.startTime = e;
    if (this.endTime != "" && this.endTime != undefined) {
      if (this.endTime < e) {
        this.TimeTableForm.controls["start_time"].setValue(null);
        Swal.fire("Alert!", "End time must be greater start time", "error");
        return;
      }
    }
  }
  entime(e: any) {
    let endTimeArr = e.split(":");
    if (this.startTime) {
      let startTimeArr = this.startTime?.split(":");
      if (startTimeArr[0] == endTimeArr[0]) {
        if (startTimeArr[1] >= endTimeArr[1]) {
          this.TimeTableForm.controls["end_time"].setValue(null);
          Swal.fire("Alert!", "End time must be greater start time", "error");
          this.endTime = e;
          return;
        }
      } else if (startTimeArr[0] >= endTimeArr[0]) {
        this.TimeTableForm.controls["end_time"].setValue(null);
        Swal.fire("Alert!", "End time must be greater start time", "error");
        this.endTime = e;
        return;
      }
    }
    this.endTime = e;
  }
  day1(e) {
    this.dayone = e;
  }
  day2(e) {
    this.daytwo = e;
  }
  day3(e) {
    this.daythree = e;
  }
  day4(e) {
    this.dayfour = e;
  }
  day5(e) {
    this.dayfive = e;
  }
  day6(e) {
    this.daysix = e;
  }
  day7(e) {
    this.dayseven = e;
  }
  openScrollableContent(longContent) {
    // this.findedVal = null;
    //this.professor_id = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.getAllDropdown(true);
    }
  }
  openActionContent(shortContent) {
    this.statusform = null;
    this.modalService.open(shortContent, { scrollable: true });
  }
  checkdate(id) {
    for (let i = 0; i < this.batchData?.length; i++) {
      if (id === this.batchData[i].id) {
        this.datecheck = this.batchData[i].batch;
      }
    }
    this.datecheckstatus = true;
    let datearr = this.datecheck.split("-");
    let today = new Date();
    this.date1.setFullYear(
      today.getFullYear(),
      Number(today.getMonth()),
      today.getDate()
    );
    this.date2.setFullYear(datearr[1]?.trim(), 11, 31);
  }
  onCreatSessionChangeEvent() {
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData?.find(
        (list) => list.session === sessionVal
      );
    }
  }

  onSubmit(status) {
    this.timebulk = [];
    if (status !== undefined && status !== "" && status !== null) {
      let a = [];
      let k = 0;

      for (let i = 0; i < this.timeList.length; i++) {
        a[i] = this.timeList[i];
        if (a[i].is_selected == true) {
          k = 1;

          this.timebulk.push(a[i].id);
        }
      }

      this.bulkTimeStatusUpdate(this.timebulk, status);
      if (k == 0) {
        Swal.fire(
          "Alert!",
          "Kindly Select any one in Time Table list",
          "error"
        );
      }
    } else {
      Swal.fire("Warning", "Please select Status", "warning");
      return false;
    }
  }

  bulkTimeStatusUpdate(id, status) {
    Swal.fire({
      title: "Are you sure?",
      text: `Are you sure you want to ${status == 9 ? "Detele" : "Change Status"
        }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let inputData = {};
        let url;
        if (status == 9) {
          url = "timetable/delete/request/create";
          inputData = {
            user_id: this.ls.get("createdBy"),
            vendor_id: this.ls.get("vendor_id"),
            role_id: this.storageService.getRole(),
            delete_type: 1,
            requester_type: "web",
            timetable_data: id,
          };
        } else {
          url = "timetable/update-bulk/status";
          inputData = {
            user_id: this.ls.get("createdBy"),
            vendor_id: this.ls.get("vendor_id"),
            id: id,
            is_active: status,
          };
        }
        if (!this.checkStatusForSelectedList(id, status)) {
          this.spinner.show();
          this.bulktimeupload = await this.globalService.update(url, inputData);

          if (this.bulktimeupload["status"] === 200) {
            Swal.fire("Success!", this.bulktimeupload["message"], "success");
            this.pageshow = true;
            this.spinner.hide();
            this.select_all = "";
            this.statusform = "";
            this.timebulk = [];
            this.getTimeTable();
          }
          if (this.bulktimeupload["status"] != 200) {
            this.pageshow = true;
            this.select_all = "";
            this.statusform = "";
            this.timebulk = [];
            this.spinner.hide();
            this.getTimeTable();
          }
        } else {
          this.spinner.hide();
          Swal.fire(
            "Warning",
            "The Status Selected should not match with the status in the Bulk-Selected List",
            "warning"
          );
        }
      } else {
        this.pageshow = true;
        this.select_all = "";
        this.statusform = "";
        this.timebulk = [];
        this.spinner.hide();
        this.getTimeTable();
      }
    });
  }

  checkStatusForSelectedList(id, status) {
    for (let i = 0; i < this.timeList.length; i++) {
      for (let j = 0; j < id.length; j++) {
        if (id[j] == this.timeList[i].id) {
          if (this.timeList[i].is_active == status) {
            return true;
          }
        }
      }
    }
  }

  onSelectAll(e: any) {
    let a = [];
    let b = [];
    for (let i = 0; i < this.timeList.length; i++) {
      a[i] = this.timeList[i];
      a[i].is_selected = e;
    }
    for (let j = 0; j < a.length; j++) {
      b[j] = a[j].id;
    }
  }
  Filter() {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.startdate + " - " + this.enddate
      );
    }

    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.prodessorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
        " " +
        proffessor[0].first_name +
        " " +
        proffessor[0].last_name
      );
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }
    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }

    this.department_id = this.searchForm.controls["depname"]?.value;
    this.classroom_id = this.searchForm.controls["classname"]?.value;
    this.subject_id = this.searchForm.controls["subname"]?.value;
    this.batch_id = this.searchForm.controls["batchname"]?.value;
    this.professor_id = this.searchForm.controls["proname"]?.value;
    this.pageshow = true;
    this.page = 1;
    this.getTimeTable(true);
  }
  res() {
    //this.findedVal = null;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    this.backendValidationErrors = null;
    this.filtervalues = false;
    this.startTime = null;
    this.endTime = null;
    this.department_id = null;
    this.classroom_id = null;
    this.subject_id = null;
    this.batch_id = null;
    this.professor_id = null;
    this.startDateFil = null;
    this.endDateFil = null;
    this.startTimeFil = null;
    this.endTimeFil = null;
    this.start_time = null;
    this.start_date = null;
    this.end_date = null;
    this.end_time = null;
    this.select_all = null;
    this.filter_from = null;
    this.filter_end = null;
    this.date1 = new Date();
    this.date2 = new Date();
    this.date3 = new Date();
    this.filter = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.getTimeTable();
  }

  async createTimeTable(form: FormGroup) {
    this.submitted = true;
    let st_time = form.value.start_time;
    let ed_time = form.value.end_time;
    const selectedDate = new Date(form.value.start_date);
    const today = new Date();
    if (selectedDate.setHours(0, 0, 0, 0) == today.setHours(0, 0, 0, 0)) {
      this.minStartTime = this.getCurrentTimeString();

    } else {
      this.minStartTime = '00:00';
    }
    if (
      form.value.day_one == "" &&
      form.value.day_two == "" &&
      form.value.day_three == "" &&
      form.value.day_four == "" &&
      form.value.day_five == "" &&
      form.value.day_six == "" &&
      form.value.day_seven == ""
    ) {
      Swal.fire("Warning!", "Please Fill Atleast One day", "warning");
    } else if (this.TimeTableForm.invalid) {
      return;
    } else if (st_time > ed_time) {
      Swal.fire("Warning!", "End time is greater than Start time", "warning");
      return false;
    }
    else if (form.value.start_time < this.minStartTime) {
      Swal.fire("Warning!", "Start time should not be less than the current time");
      return false;

    } else {
      var startUTCDate = moment(
        this.startDate + " " + this.startTime,
        "YYYY-MM-DD HH:mm:ss"
      ).utc();
      var endUTCDate = moment(
        this.endDate + " " + this.endTime,
        "YYYY-MM-DD HH:mm:ss"
      ).utc();
      const inputData = {
        id: form.value.id,
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        department_id: form.value.department_id,
        classroom_id: form.value.classroom_id,
        subject_id: form.value.subject_id,
        batch_id: form.value.batch_id,
        professor_id: form.value.professor_id,
        live_stream: this.liveStream,
        start_date: isNaN(startUTCDate.toDate().getTime())
          ? null
          : startUTCDate.format("YYYY-MM-DD"),
        end_date: isNaN(endUTCDate.toDate().getTime())
          ? null
          : endUTCDate.format("YYYY-MM-DD"),
        start_time: startUTCDate.format("HH:mm:ss"),
        end_time: endUTCDate.format("HH:mm:ss"),

        day_one: this.dayone ? (this.dayone === true ? "1" : "0") : "0",
        day_two: this.daytwo ? (this.daytwo === true ? "1" : "0") : "0",
        day_three: this.daythree ? (this.daythree === true ? "1" : "0") : "0",
        day_four: this.dayfour ? (this.dayfour === true ? "1" : "0") : "0",
        day_five: this.dayfive ? (this.dayfive === true ? "1" : "0") : "0",
        day_six: this.daysix ? (this.daysix === true ? "1" : "0") : "0",
        day_seven: this.dayseven ? (this.dayseven === true ? "1" : "0") : "0",
        role_id: this.storageService.getRole(),
        session_id: this.findedVal?.id,
      };
      this.spinner.show();
      this.stucreate = await this.globalService.create(
        "timetable/create",
        inputData
      );
      if (this.stucreate["status"] === 200) {
        Swal.fire("Success!", this.stucreate["message"], "success");
        this.pageshow = true;
        this.getTimeTable();
        (this.dayone = 0),
          (this.daytwo = 0),
          (this.daythree = 0),
          (this.dayfour = 0),
          (this.dayfive = 0),
          (this.daysix = 0),
          (this.dayseven = 0);
        this.reset();
        this.spinner.hide();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
      } else if (this.stucreate["status"] === 422) {
        this.backendValidationErrors = this.stucreate?.error["content"];
      }
      this.startTime = "";
      this.endTime = "";
      this.cancelFields();
      this.spinner.hide();
    }
  }

  async getTimeTable(isFilter?) {
    this.spinner.show();
    if (this.page === 1) {
      this.timeList = [];
    }
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      role_id: this.storageService.getRole(),
      department_id: this.department_id,
      classroom_id: this.classroom_id,
      subject_id: this.subject_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      session_id: this.findedVal?.id,
      start_date: isFilter
        ? isNaN(startUTCDate.toDate().getTime())
          ? null
          : startUTCDate.format("YYYY-MM-DD")
        : "",
      end_date: isFilter
        ? isNaN(endUTCDate.toDate().getTime())
          ? null
          : endUTCDate.format("YYYY-MM-DD")
        : "",
    };

    this.gettime = await this.globalService.get("timetable/list", filter);
    this.total_count = this.gettime["content"].count;
    if (this.gettime["status"] === 200) {
      this.timeList = this.gettime["content"]["rows"];
      this.timeList = this.timeList.map((list) => {
        list["isExpand"] = false;
        return list;
      });
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    }

    (error) => {
      this.timeList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }

  View(id) {
    this.router.navigateByUrl(`/view-video/${id}`);
  }

  async editTimeTable(id) {
    this.getAllDropdown(true);
    let previousTimeList = [...this.timeList];
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      this.editbut = true;
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.active = 2;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.storageService.getRole(),
          id: id,
        };
        this.edittime = await this.globalService.get("timetable/get", filter);
        let comp_details = this.edittime["content"];
        if (this.edittime["status"] === 200) {
          this.TimeTableForm.controls["id"].setValue(comp_details.id);
          this.TimeTableForm.controls["department_id"].setValue(
            comp_details.department_id
          );
          this.TimeTableForm.controls["classroom_id"].setValue(
            comp_details.classroom_id
          );
          // let findedProfessor = previousTimeList.filter((list) => {
          //   if (list.professor_id === comp_details.professor_id) {
          //     return list;
          //   }
          // });
          const selectedProfessor = previousTimeList.find((list) => {
            return list.professor_id === comp_details.professor_id;
          });

          if (selectedProfessor) {
            this.findedInactiveProfessorId = selectedProfessor.professor.id;

            const professorData = {
              id: selectedProfessor.professor.id,
              username: selectedProfessor.professor.username,
              first_name: selectedProfessor.professor.first_name,
              last_name: selectedProfessor.professor.last_name,
              email_address: selectedProfessor.professor.email_address,
              hod: selectedProfessor.professor.hod,
              userByRole: [
                {
                  id: 4,
                  role: "Professor",
                  userRole: {
                    role_id: 4,
                  },
                },
              ],
            };

            this.prodessorData.push(professorData);
            this.isActiveProfessor = selectedProfessor.professor.is_active;
            const professorDropdown = this.TimeTableForm.get("professor_id");
            professorDropdown.setValue(selectedProfessor.professor.id);
          }
          this.TimeTableForm.controls["professor_id"].setValue(
            comp_details.professor_id
          );
          this.TimeTableForm.controls["subject_id"].setValue(
            comp_details.subject_id
          );
          this.TimeTableForm.controls["batch_id"].setValue(
            comp_details.batch_id
          );
          this.TimeTableForm.controls["end_date"].setValue(
            comp_details.end_date
          );
          this.TimeTableForm.controls["start_date"].setValue(
            comp_details.start_date
          );
          this.TimeTableForm.controls["session"].setValue(
            this.sessionData?.find(
              (list) => list.id === comp_details.session_id
            )?.session
          );
          this.spinner.hide();
          this.d = this.getUtcToLocale(
            comp_details.start_date,
            comp_details.start_time,
            false
          );
          this.startTime = moment(this.d).format("HH:mm:ss");

          this.TimeTableForm.controls["start_time"].setValue(
            moment(this.d).format("HH:mm:ss")
          );
          this.d1 = this.getUtcToLocale(
            comp_details.end_date,
            comp_details.end_time,
            false
          );
          this.endTime = moment(this.d1).format("HH:mm:ss");

          this.TimeTableForm.controls["end_time"].setValue(
            moment(this.d1).format("HH:mm:ss")
          );

          this.TimeTableForm.controls["day_one"].setValue(
            comp_details.timetable_day.day_one
          );
          this.TimeTableForm.controls["day_two"].setValue(
            comp_details.timetable_day.day_two
          );
          this.TimeTableForm.controls["day_three"].setValue(
            comp_details.timetable_day.day_three
          );
          this.TimeTableForm.controls["day_four"].setValue(
            comp_details.timetable_day.day_four
          );
          this.TimeTableForm.controls["day_five"].setValue(
            comp_details.timetable_day.day_five
          );
          this.TimeTableForm.controls["day_six"].setValue(
            comp_details.timetable_day.day_six
          );
          this.TimeTableForm.controls["day_seven"].setValue(
            comp_details.timetable_day.day_seven
          );
          this.TimeTableForm.controls.isActive.setValue(
            comp_details.live_stream == 1 ? true : false
          );
          this.liveStream = comp_details.live_stream;
          for (let i = 0; i < this.batchData?.length; i++) {
            if (comp_details.batch_id === this.batchData[i].id) {
              this.datecheck = this.batchData[i].batch;
            }
          }

          let datearr = this.datecheck.split("-");
          let today = new Date();
          this.date1.setFullYear(
            today.getFullYear(),
            Number(today.getMonth()),
            today.getDate()
          );
          this.date2.setFullYear(datearr[1]?.trim(), 11, 31);

          this.dayone1 = comp_details.timetable_day.day_one;
          this.dayone2 = comp_details.timetable_day.day_two;
          this.dayone3 = comp_details.timetable_day.day_three;
          this.dayone4 = comp_details.timetable_day.day_four;
          this.dayone5 = comp_details.timetable_day.day_five;
          this.dayone6 = comp_details.timetable_day.day_six;
          this.dayone7 = comp_details.timetable_day.day_seven;
          this.editid = comp_details.id;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
        this.spinner.hide();
      }
    });
  }

  reset() {
    this.submitted = false;
    this.TimeTableForm.reset();
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getTimeTable();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getTimeTable();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getTimeTable();
  }

  async updateTimeTable(form: FormGroup) {
    this.submitted = true;

    if (
      form.value.day_one == "" &&
      form.value.day_two == "" &&
      form.value.day_three == "" &&
      form.value.day_four == "" &&
      form.value.day_five == "" &&
      form.value.day_six == "" &&
      form.value.day_seven == ""
    ) {
      Swal.fire("Warning!", "Please Fill Atleast One day", "warning");
    } else if (this.TimeTableForm.invalid) {
      return;
    } else {
      var startUTCDate = moment(
        (this.startDate ? this.startDate : form.value.start_date) +
        " " +
        (this.startTime ? this.startTime : form.value.start_time),
        "YYYY-MM-DD HH:mm:ss"
      ).utc();
      var endUTCDate = moment(
        (this.endDate ? this.endDate : form.value.end_date) +
        " " +
        (this.endTime ? this.endTime : form.value.end_time),
        "YYYY-MM-DD HH:mm:ss"
      ).utc();

      const inputData = {
        id: form.value.id,
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        department_id: form.value.department_id,
        classroom_id: form.value.classroom_id,
        subject_id: form.value.subject_id,
        batch_id: form.value.batch_id,
        professor_id: form.value.professor_id,
        live_stream: this.liveStream,

        start_date: startUTCDate.format("YYYY-MM-DD"),
        end_date: endUTCDate.format("YYYY-MM-DD"),
        start_time: startUTCDate.format("HH:mm:ss"),
        end_time: endUTCDate.format("HH:mm:ss"),
        day_one: form.value.day_one == 1 ? "1" : "0",
        day_two: form.value.day_two == 1 ? "1" : "0",
        day_three: form.value.day_three == 1 ? "1" : "0",
        day_four: form.value.day_four == 1 ? "1" : "0",
        day_five: form.value.day_five == 1 ? "1" : "0",
        day_six: form.value.day_six == 1 ? "1" : "0",
        day_seven: form.value.day_seven == 1 ? "1" : "0",
        role_id: this.storageService.getRole(),
        session_id: this.sessionData?.find(
          (list) => list.session === form.value.session
        )?.id,
      };

      this.spinner.show();
      this.updatetime = await this.globalService.update(
        "timetable/update",
        inputData
      );

      if (this.updatetime["status"] === 200) {
        Swal.fire("Success!", this.updatetime["message"], "success");
        this.spinner.show();
        this.pageshow = true;
        this.getTimeTable(true);
        this.chiparray = [];
        let currentsession = this.storageService.getCurrentSession(this.sessionData)?.session;
        if (currentsession !== undefined) {
          this.chiparray.push(
            "Session : " + currentsession
          );
        }
        this.editbut = false;
        (this.dayone = 0),
          (this.daytwo = 0),
          (this.daythree = 0),
          (this.dayfour = 0),
          (this.dayfive = 0),
          (this.daysix = 0),
          (this.dayseven = 0);
        this.reset();
        this.entryFields = false;
        this.createNew = true;
      }
      this.cancelFields();
      this.spinner.hide();
    }
  }

  async deleteTimeTable(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed === true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          role_id: this.storageService.getRole(),
        };
        this.deletetime = await this.globalService.delete(
          "timetable/delete",
          filter
        );
        if (this.deletetime["status"] === 200) {
          this.timeList = [];
          Swal.fire("Success!", this.deletetime["message"], "success");
          this.pageshow = true;
          this.getTimeTable();
        }
      }
    });
    this.spinner.hide();
  }
  setFilterStartDate(filter_date) {
    if (!filter_date) {
      return false;
    }

    let from = moment(filter_date).format("YYYY-MM-DD");

    this.start_date = this.datepipe.transform(from, "yyyy-MM-dd");
  }

  formAddReset() {
    this.TimeTableForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.TimeTableForm.controls["id"].setValue(this.edittime["content"].id);
    this.TimeTableForm.controls["department_id"].setValue(
      this.edittime["content"].department_id
    );
    this.TimeTableForm.controls["classroom_id"].setValue(
      this.edittime["content"].classroom_id
    );
    this.TimeTableForm.controls["professor_id"].setValue(
      this.edittime["content"].professor_id
    );
    this.TimeTableForm.controls["subject_id"].setValue(
      this.edittime["content"].subject_id
    );
    this.TimeTableForm.controls["batch_id"].setValue(
      this.edittime["content"].batch_id
    );
    this.TimeTableForm.controls["end_date"].setValue(
      this.edittime["content"].end_date
    );
    this.TimeTableForm.controls["start_date"].setValue(
      this.edittime["content"].start_date
    );
    this.d = this.getUtcToLocale(
      this.edittime["content"].start_date,
      this.edittime["content"].start_time,
      false
    );

    this.TimeTableForm.controls["start_time"].setValue(
      moment(this.d).format("HH:mm:ss")
    );
    this.d1 = this.getUtcToLocale(
      this.edittime["content"].end_date,
      this.edittime["content"].end_time,
      false
    );

    this.TimeTableForm.controls["end_time"].setValue(
      moment(this.d1).format("HH:mm:ss")
    );

    this.TimeTableForm.controls["day_one"].setValue(
      this.edittime["content"].timetable_day.day_one
    );
    this.TimeTableForm.controls["day_two"].setValue(
      this.edittime["content"].timetable_day.day_two
    );
    this.TimeTableForm.controls["day_three"].setValue(
      this.edittime["content"].timetable_day.day_three
    );
    this.TimeTableForm.controls["day_four"].setValue(
      this.edittime["content"].timetable_day.day_four
    );
    this.TimeTableForm.controls["day_five"].setValue(
      this.edittime["content"].timetable_day.day_five
    );
    this.TimeTableForm.controls["day_six"].setValue(
      this.edittime["content"].timetable_day.day_six
    );
    this.TimeTableForm.controls["day_seven"].setValue(
      this.edittime["content"].timetable_day.day_seven
    );
    this.TimeTableForm.controls.isActive.setValue(
      this.edittime["content"].live_stream == 1 ? true : false
    );
    this.TimeTableForm.reset();
    this.TimeTableForm.get("id").setValue(this.edittime["content"].id);
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }

  TimeTableStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.statusupdate = await this.globalService.update(
          "timetable/update/status",
          inputData
        );
        if (this.statusupdate["status"] === 200) {
          Swal.fire("Success!", this.statusupdate["message"], "success");
          this.pageshow = true;
          this.getTimeTable();
        }
        if (this.statusupdate["status"] != 200) {
          this.pageshow = true;
          this.getTimeTable();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getTimeTable();
      }
    });
    this.spinner.hide();
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }

  async BulkUpload(form: FormGroup) {
    this.spinner.show();
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      this.spinner.hide();
      Swal.fire("", "Please upload the file", "error");
      return;
    }
    let dataExport = [];
    let file;
    let files;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);

    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }

      if (file.size > 2097152) {
        this.spinner.hide();
        Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
        return false;
      } else if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("requester_type", "web");
        formdata.append("role_id", String(this.storageService.getRole()));
        var timeZone = moment(this.maxCreateEditDate).format("Z");
        formdata.append("timezone", timeZone);
        this.spinner.show();
        reader.onload = async (e: any) => {
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.schedulebulk = await this.globalService.create(
              "timetable/bulk/upload",
              formdata
            );
            if (this.schedulebulk["content"] == undefined) {
              this.spinner.hide();
            }

            if (this.schedulebulk["status"] === 200) {
              let bulk = this.schedulebulk["content"];
              const expectedHeaders = [
                "department",
                "classroom",
                "subject",
                "batch",
                "professor",
                "session",
                "start_date",
                "end_date",
                "start_time",
                "end_time",
                "days",
              ];

              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    department: bulk[i].department,
                    classroom: bulk[i].classroom,
                    subject: bulk[i].subject,
                    batch: bulk[i].batch,
                    professor: bulk[i].professor,
                    start_date: bulk[i].start_date,
                    end_date: bulk[i].end_date,
                    start_time: bulk[i].start_time,
                    end_time: bulk[i].end_time,
                    days: bulk[i].days,
                    Livestream: bulk[i].live_stream || 0,
                    session: bulk[i].session,
                    message: bulk[i].message,
                  });
                }
                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "Timetable List"
                );

                Swal.fire("Success!", this.schedulebulk["message"], "success");
                this.pageshow = true;
                this.getTimeTable();
                this.bulk_form.reset();
                this.spinner.hide();
              }
            }
          }
        };
      }
      this.spinner.hide();
      this.cancelFields();
    }
  }

  // async downloadSampleTemplate() {
  //   await this.getAllDropdown();
  //   setTimeout(() => {
  //     const deptList = [];
  //     const classList = [];
  //     const subjectList = [];
  //     const batchList = [];
  //     const professorList = [];
  //     const sessionList = [];
  //     const livestreamList = ["0", "1"];
  //     this.dept?.forEach((e) => {
  //       deptList.push(e.name);
  //     });
  //     this.class?.forEach((e) => {
  //       classList.push(e.name);
  //     });
  //     this.subjectData?.forEach((e) => {
  //       subjectList.push(e.name);
  //     });
  //     this.batchData?.forEach((e) => {
  //       batchList.push(e.batch);
  //     });
  //     this.prodessorData?.forEach((e) => {
  //       professorList.push(e.email_address);
  //     });
  //     this.sessionData?.forEach((e) => {
  //       sessionList.push(e.session);
  //     });

  //     const workbook = new Excel.Workbook();

  //     // Keep Sheet1 as the first visible sheet.
  //     const worksheet = workbook.addWorksheet("Sheet1");

  //     // Store dropdown sources in a separate hidden sheet instead of hidden fields in Sheet1.
  //     const listSheet = workbook.addWorksheet("Lists", { state: "veryHidden" });
  //     for (let index = 0; index < deptList.length; index++) {
  //       listSheet.getCell(`A${index + 1}`).value = deptList[index];
  //     }
  //     for (let index = 0; index < classList.length; index++) {
  //       listSheet.getCell(`B${index + 1}`).value = classList[index];
  //     }
  //     for (let index = 0; index < subjectList.length; index++) {
  //       listSheet.getCell(`C${index + 1}`).value = subjectList[index];
  //     }
  //     for (let index = 0; index < batchList.length; index++) {
  //       listSheet.getCell(`D${index + 1}`).value = batchList[index];
  //     }
  //     for (let index = 0; index < professorList.length; index++) {
  //       listSheet.getCell(`E${index + 1}`).value = professorList[index];
  //     }
  //     for (let index = 0; index < sessionList.length; index++) {
  //       listSheet.getCell(`F${index + 1}`).value = sessionList[index];
  //     }
  //     for (let index = 0; index < livestreamList.length; index++) {
  //       listSheet.getCell(`G${index + 1}`).value = livestreamList[index];
  //     }

  //     worksheet.getCell("A1").value = "Sno";
  //     worksheet.getCell("B1").value = "Department";
  //     worksheet.getCell("C1").value = "Classroom";
  //     worksheet.getCell("D1").value = "Subject";
  //     worksheet.getCell("E1").value = "Batch";
  //     worksheet.getCell("F1").value = "Professor";
  //     worksheet.getCell("G1").value = "Start_date";
  //     worksheet.getCell("H1").value = "End_date";
  //     worksheet.getCell("I1").value = "Start_time";
  //     worksheet.getCell("J1").value = "End_time";
  //     worksheet.getCell("K1").value = "Days";
  //     worksheet.getCell("L1").value = "Livestream";
  //     worksheet.getCell("M1").value = "Session";

  //     worksheet.getCell("A2").value = "1";

  //     worksheet.getCell("G2").value = "MM/DD/YYYY";
  //     worksheet.getCell("H2").value = "MM/DD/YYYY";
  //     worksheet.getCell("I2").value = "HH-MM";
  //     worksheet.getCell("J2").value = "HH-MM";
  //     worksheet.getColumn(9).numFmt = "@";
  //     worksheet.getColumn(10).numFmt = "@";
  //     worksheet.getCell("K2").value = "1,2,3,4,5,6,7";

  //     // Upload accepts only 100 records, so add validations only for rows 2..101.
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`B${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$A$1:$A$${deptList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`C${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$B$1:$B$${classList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`D${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$C$1:$C$${subjectList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`E${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$D$1:$D$${batchList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`F${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$E$1:$E$${professorList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`M${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$F$1:$F$${sessionList.length || 1}`],
  //       };
  //     }
  //     for (let index = 2; index <= 101; index++) {
  //       worksheet.getCell(`L${index}`).dataValidation = {
  //         type: "list",
  //         allowBlank: false,
  //         showInputMessage: false,
  //         formulae: [`Lists!$G$1:$G$${livestreamList.length}`],
  //       };
  //     }

  //     worksheet.getColumn(1).width = 20;
  //     worksheet.getColumn(2).width = 20;
  //     worksheet.getColumn(3).width = 20;
  //     worksheet.getColumn(4).width = 20;
  //     worksheet.getColumn(5).width = 20;
  //     worksheet.getColumn(6).width = 20;
  //     worksheet.getColumn(7).width = 20;
  //     worksheet.getColumn(8).width = 20;
  //     worksheet.getColumn(9).width = 20;
  //     worksheet.getColumn(10).width = 20;
  //     worksheet.getColumn(11).width = 20;
  //     worksheet.getColumn(12).width = 20;
  //     worksheet.getColumn(13).width = 20;

  //     workbook.xlsx.writeBuffer().then((data: any) => {
  //       const blob = new Blob([data], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       saveAs(blob, "Timetable Sample List" + ".xlsx");
  //     });
  //   }, 100);
  // }

  async downloadSampleTemplate() {

    await this.getAllDropdown();

    setTimeout(() => {

      let temp = [];
      let temp1 = [];
      let temp2 = [];
      let temp3 = [];
      let temp4 = [];
      let temp5 = [];
      let temp6 = ["0", "1"];

      this.dept?.forEach((e) => {
        temp.push(e.name);
      });

      this.class?.forEach((e) => {
        temp1.push(e.name);
      });

      this.subjectData?.forEach((e) => {
        temp2.push(e.name);
      });

      this.batchData?.forEach((e) => {
        temp3.push(e.batch);
      });

      this.prodessorData?.forEach((e) => {
        temp4.push(e.email_address);
      });

      this.sessionData?.forEach((e) => {
        temp5.push(e.session);
      });

      const workbook = new Excel.Workbook();

      // Main worksheet
      const worksheet = workbook.addWorksheet("Sheet1");

      // Hidden master worksheet for dropdown values
      const masterSheet = workbook.addWorksheet("Master");
      masterSheet.state = "veryHidden";

      // =========================
      // Headers
      // =========================

      worksheet.getCell("A1").value = "Sno";
      worksheet.getCell("B1").value = "Department";
      worksheet.getCell("C1").value = "Classroom";
      worksheet.getCell("D1").value = "Subject";
      worksheet.getCell("E1").value = "Batch";
      worksheet.getCell("F1").value = "Professor";
      worksheet.getCell("G1").value = "Start_date";
      worksheet.getCell("H1").value = "End_date";
      worksheet.getCell("I1").value = "Start_time";
      worksheet.getCell("J1").value = "End_time";
      worksheet.getCell("K1").value = "Days";
      worksheet.getCell("L1").value = "Livestream";
      worksheet.getCell("M1").value = "Session";

      // =========================
      // Sample row
      // =========================

      worksheet.getCell("A2").value = "1";
      worksheet.getCell("G2").value = "MM/DD/YYYY";
      worksheet.getCell("H2").value = "MM/DD/YYYY";
      worksheet.getCell("I2").value = "HH-MM";
      worksheet.getCell("J2").value = "HH-MM";
      worksheet.getCell("K2").value = "1,2,3,4,5,6,7";

      worksheet.getColumn(9).numFmt = "@";
      worksheet.getColumn(10).numFmt = "@";

      // =========================
      // Column Widths
      // =========================

      for (let i = 1; i <= 13; i++) {
        worksheet.getColumn(i).width = 20;
      }

      // =========================
      // Store dropdown values in master sheet
      // =========================

      temp.forEach((item, index) => {
        masterSheet.getCell(`A${index + 1}`).value = item;
      });

      temp1.forEach((item, index) => {
        masterSheet.getCell(`B${index + 1}`).value = item;
      });

      temp2.forEach((item, index) => {
        masterSheet.getCell(`C${index + 1}`).value = item;
      });

      temp3.forEach((item, index) => {
        masterSheet.getCell(`D${index + 1}`).value = item;
      });

      temp4.forEach((item, index) => {
        masterSheet.getCell(`E${index + 1}`).value = item;
      });

      temp5.forEach((item, index) => {
        masterSheet.getCell(`F${index + 1}`).value = item;
      });

      temp6.forEach((item, index) => {
        masterSheet.getCell(`G${index + 1}`).value = item;
      });

      // =========================
      // Apply dropdown validations
      // =========================

      for (let i = 2; i <= 2500; i++) {

        worksheet.getCell(`B${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$A$1:$A$${temp.length}`],
        };

        worksheet.getCell(`C${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$B$1:$B$${temp1.length}`],
        };

        worksheet.getCell(`D${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$C$1:$C$${temp2.length}`],
        };

        worksheet.getCell(`E${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$D$1:$D$${temp3.length}`],
        };

        worksheet.getCell(`F${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$E$1:$E$${temp4.length}`],
        };

        worksheet.getCell(`L${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$G$1:$G$${temp6.length}`],
        };

        worksheet.getCell(`M${i}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`Master!$F$1:$F$${temp5.length}`],
        };
      }

      // =========================
      // Download Excel
      // =========================

      workbook.xlsx.writeBuffer().then((data: any) => {

        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Timetable Sample List.xlsx");

      });

    }, 100);
  }


  resetbulk() {
    this.bulk_form.reset();
  }
  onPageCountChange(value) {
    if (value >= 5) {
      this.page_size = value;
    }
    this.getTimeTable();
  }
  async onRequestList(content) {
    this.spinner.show();
    if (this.ls.get("token")) {
      this.modalService.open(content, { scrollable: true, size: "xl" });
    }
    let url = "timetable/delete/request/list";
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      delete_type: 1,
      requester_type: "web",
    };

    let sourceData = await this.globalService.get(url, filter);
    this.requestListData = sourceData["content"]["rows"];
    this.spinner.hide();
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  onLiveStreaming(value) {
    if (value) {
      this.liveStream = 1;
    } else {
      this.liveStream = 0;
    }
  }

  isDisable(date, time, timetable_delete): boolean {
    return (
      new Date(`${date} ${time}`).getTime() < new Date().getTime() ||
      timetable_delete?.length >= 1
    );
  }

  getCurrentTimeString(): string {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
}
